module.exports = __webpack_public_path__ + "static/img/l8.7c1a296.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing_page/l8.jpg
// module id = 641
// module chunks = 0